import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";
import { RenderNavItem } from "../components/RenderNavItem";
import { ProjectCBPLeftManuList } from "../utils/constants";

const Vision_Strategy = () => {
  const { t } = useTranslation();

  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
            <div className="site-menu">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {ProjectCBPLeftManuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">
                      {t(
                        "Capacity Building Programme (CBP) :: Vision and Strategy"
                      )}
                    </h3>
                  </div>
                  <div className="col-lg-12 about-head1">
                    <h5 className="fontSizeClass">
                      <strong>{t("Foreword")}</strong>
                    </h5>
                    <p className="mt-2">
                      {t(
                        "We have launched a Capacity Building Programme in the Kolkata Municipal Corporation. It is meant to add strength and vigour to the civic body. Ours is an old organization, one of the oldest of its kind in the country. With age comes obsolescence. The Capacity Building Programme is meant to renew our energy and to re-invigorate our limbs. The Department for International Development (DFID), Government of United Kingdom, has been helping us in this programme and we are grateful to them."
                      )}
                      .
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 about-head1">
              <p className="mt-2">
                {t(
                  "We present now the vision and the strategy paper for this Capacity Building Programme. This is a road map for us. We present in this paper an omnibus perspective, as well as sectoral action plans. The paper provides the milestones for the future and provides the anchors and the moorings for our journey ahead."
                )}
                .
              </p>
              <p className="mt-2">
                {t(
                  "Sri Alapan Bandyopadhyay, IAS, the Municipal Commissioner, has ably led the team that has prepared the document. Sri Sahidul Islam, the Joint Municipal Commissioner (Development) has worked painstakingly to produce the draft. Our consultants, the KPMG etc, have worked hard. The contributions from the different Members of the Mayor-in-Council, our Borough Chairmen and the Controlling Officers and staff across the organization are acknowledged. They have deliberated upon the contents of the document over the months. The DFID officials have also enriched us with their suggestions. It is a collective effort. We propose to steer ourselves with the vision and strategy that we now present."
                )}
                .
              </p>
              <p className="mt-2">
                Let this volume be treated as{" "}
                <DownloadFileByFileStoreId
                  fileStoreId="5f6af4ed-19c5-44e8-8be3-c9c9c35d032a"
                  label="Volume-I"
                  classAdd={false}
                />{" "}
                of a series of booklets that we intend to publish one by one. In
                the succeeding volumes, we shall present our specific action
                programmes/circulars/orders/notifications in different
                directions.
              </p>
            </div>
            <br />
            <div className="col-lg-4 about-head1 text-center mt-5">
              <p> Dated : 31 st March, 2006 </p>
            </div>
            <div className="col-lg-4 about-head1 text-center mt-5">
              <DownloadFileByFileStoreId
                fileStoreId="5f6af4ed-19c5-44e8-8be3-c9c9c35d032a"
                label="Capacity Building Programme Volume-I Vision & Strategy"
              />
            </div>
            <div className="col-lg-4 about-head1 right text-center mt-5">
              <strong>
                (Bikash Ranjan Bhattacharyya) <br /> Mayor <br /> The Kolkata
                Municipal Corporation
              </strong>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Vision_Strategy;
